module.exports = __webpack_public_path__ + "img/3_Train-01-center.255b6739.png";